import React from "react";
import { SectionHeader } from "./SectionHeader";

export const Features = ({ data, section }) => {
  const s = section || {};
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1">
          <SectionHeader heading={s.heading} subheading={s.subheading} />
        </div>
        <div className="row mb-4">
          {data
            ? data.map((d, i) => (
                <div key={`${d.title}-${i}`} className="col-xs-6 col-md-3">
                  <i className={d.icon}></i>
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : null}
        </div>
      </div>
    </div>
  );
};
